module.exports = __webpack_public_path__ + "img/23.3e1f06dd.jpeg";